/** Response from POST /v2.0/sso/ticket */
export interface SsoTicketResponse {
  /** The random string ticket to be used as Bearer token for /script-assist-sso/init */
  sso_ticket: string;
  /** TTL in seconds */
  expires_in: number;
}

/** Supported Script Assist services */
export type ScriptAssistService = 'CBPM' | 'ADHD';

/** Numeric service codes used in the ?flow= query param */
export const SA_AUTH_SERVICE_MAP: Record<ScriptAssistService, number> = {
  CBPM: 2,
  ADHD: 3,
};

export const SA_AUTH_SERVICE_CODE_MAP: Record<number, ScriptAssistService> = Object.fromEntries(
  Object.entries(SA_AUTH_SERVICE_MAP).map(([k, v]) => [v, k])
) as Record<number, ScriptAssistService>;
